export default "__VITE_ASSET__DRQLKwEP__"